/**
 * Alu-Cab Australia YouTube Shorts carousel (instant load, no network fetch).
 * Manage videos in the theme editor: YouTube Shorts feed → Video IDs.
 */
(function () {
  function extractVideoId(token) {
    if (!token) return '';
    var trimmed = token.trim();
    if (!trimmed) return '';

    if (/^[\w-]{11}$/.test(trimmed)) return trimmed;

    var match;
    match = trimmed.match(/(?:youtube\.com\/shorts\/|youtu\.be\/)([\w-]{11})/i);
    if (match) return match[1];

    match = trimmed.match(/[?&]v=([\w-]{11})/i);
    if (match) return match[1];

    match = trimmed.match(/youtube\.com\/embed\/([\w-]{11})/i);
    if (match) return match[1];

    return '';
  }

  function parseManualIds(raw) {
    if (!raw || typeof raw !== 'string') return [];
    return raw
      .split(/[\s,]+/)
      .map(extractVideoId)
      .filter(function (id) {
        return id.length === 11;
      });
  }

  function getEmbedUrl(videoId) {
    return (
      'https://www.youtube-nocookie.com/embed/' +
      videoId +
      '?playsinline=1&rel=0&modestbranding=1&autoplay=1'
    );
  }

  function getPreviewEmbedUrl(videoId) {
    return (
      'https://www.youtube-nocookie.com/embed/' +
      videoId +
      '?playsinline=1&rel=0&modestbranding=1&mute=1&autoplay=1&loop=1&controls=0&playlist=' +
      videoId
    );
  }

  function buildSlide(videoId) {
    var slide = document.createElement('div');
    slide.className = 'swiper-slide';
    var wrap = document.createElement('div');
    wrap.className = 'youtube-shorts-feed__embed';
    wrap.tabIndex = 0;
    wrap.setAttribute('role', 'button');
    wrap.dataset.videoId = videoId;
    wrap.setAttribute('aria-label', 'Open Alu-Cab Australia YouTube Short');

    var iframe = document.createElement('iframe');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('title', 'Alu-Cab Australia YouTube Short preview');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.setAttribute('tabindex', '-1');
    iframe.src = getPreviewEmbedUrl(videoId);

    wrap.appendChild(iframe);
    slide.appendChild(wrap);
    return slide;
  }

  function init(root) {
    if (root.dataset.shortsInitialized === 'true') return;
    var maxVideos = parseInt(root.dataset.maxVideos || '12', 10);
    var autoplayMs = parseInt(root.dataset.autoplayMs || '5000', 10);
    var manualIds = parseManualIds(root.dataset.manualIds || '');
    var swiperEl = root.querySelector('.youtube-shorts-swiper');
    var wrapper = root.querySelector('[data-shorts-wrapper]');
    var statusEl = root.querySelector('[data-shorts-status]');
    var modal = root.querySelector('[data-shorts-modal]');
    var modalFrame = root.querySelector('[data-shorts-modal-frame]');
    var modalClose = root.querySelector('[data-shorts-modal-close]');
    var activeSwiper = null;

    if (!swiperEl || !wrapper) return;

    function showStatus(msg) {
      if (!statusEl) return;
      statusEl.hidden = !msg;
      statusEl.textContent = msg || '';
    }

    function clearModal() {
      if (modalFrame) modalFrame.textContent = '';
      if (activeSwiper && activeSwiper.autoplay) activeSwiper.autoplay.start();
    }

    function openModal(videoId) {
      if (!modal || !modalFrame || !videoId) return;
      if (activeSwiper && activeSwiper.autoplay) activeSwiper.autoplay.stop();

      var iframe = document.createElement('iframe');
      iframe.setAttribute('title', 'Alu-Cab Australia YouTube Short');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      );
      iframe.setAttribute('allowfullscreen', '');
      iframe.src = getEmbedUrl(videoId);

      modalFrame.textContent = '';
      modalFrame.appendChild(iframe);

      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
    }

    var list = manualIds.slice(0, maxVideos);

    if (!list.length) {
      showStatus('Add Shorts in the theme editor under Video IDs (one URL or ID per line).');
      return;
    }

    wrapper.textContent = '';
    list.forEach(function (id) {
      wrapper.appendChild(buildSlide(id));
    });
    root.dataset.shortsInitialized = 'true';

    if (typeof Swiper === 'undefined') {
      showStatus('Carousel could not load. Refresh the page.');
      return;
    }

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    var loop = list.length >= 7;
    /* Phone: 2.5 slides (two full + peek of next); centered balances the crop. */
    activeSwiper = new Swiper(swiperEl, {
      slidesPerView: 2.5,
      spaceBetween: 10,
      centeredSlides: true,
      loop: loop,
      speed: 600,
      autoplay: {
        delay: autoplayMs,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: root.querySelector('.swiper-button-next'),
        prevEl: root.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: root.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        800: { slidesPerView: 3, centeredSlides: false },
        1024: { slidesPerView: 4, centeredSlides: false },
        1280: { slidesPerView: 5, centeredSlides: false },
        1366: { slidesPerView: 5, centeredSlides: false },
        1920: { slidesPerView: 6, centeredSlides: false },
      },
    });

    wrapper.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-video-id]');
      if (!trigger) return;
      openModal(trigger.dataset.videoId);
    });

    wrapper.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var trigger = event.target.closest('[data-video-id]');
      if (!trigger) return;
      event.preventDefault();
      openModal(trigger.dataset.videoId);
    });

    if (modal) {
      modal.addEventListener('close', clearModal);
      modal.addEventListener('click', function (event) {
        if (event.target === modal) modal.close();
      });
    }

    if (modalClose) {
      modalClose.addEventListener('click', function () {
        if (modal && typeof modal.close === 'function') {
          modal.close();
        } else {
          clearModal();
          if (modal) modal.removeAttribute('open');
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-youtube-shorts-feed]').forEach(init);
  });

  document.addEventListener('shopify:section:load', function (ev) {
    var root =
      ev.target &&
      ev.target.querySelector &&
      ev.target.querySelector('[data-youtube-shorts-feed]');
    if (!root) return;
    root.dataset.shortsInitialized = 'false';
    var w = root.querySelector('[data-shorts-wrapper]');
    if (w) w.textContent = '';
    init(root);
  });
})();
